import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import appRs from '../App.reducer';
const reducers = combineReducers({ appRs });

const configureStore = preloadedState => createStore(
    reducers,
    preloadedState,
    applyMiddleware(thunk)
);

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/index.js